import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { TreatmentsPage } from './pages/TreatmentsPage';
import { TreatmentDetailPage } from './pages/TreatmentDetailPage';
import { ContactPage } from './pages/ContactPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { AnalyticsManager } from './components/AnalyticsManager';

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<AppLayout><HomePage /></AppLayout>} />
      <Route path="/om-mig" element={<AppLayout><AboutPage /></AppLayout>} />
      <Route path="/behandlinger" element={<AppLayout><TreatmentsPage /></AppLayout>} />
      <Route path="/behandlinger/:slug" element={<AppLayout><TreatmentDetailPage /></AppLayout>} />
      <Route path="/kontakt" element={<AppLayout><ContactPage /></AppLayout>} />

      {/* Redirect routes for backward compatibility */}
      <Route path="/about" element={<Navigate to="/om-mig" replace />} />
      <Route path="/treatments" element={<Navigate to="/behandlinger" replace />} />
      <Route path="/contact" element={<Navigate to="/kontakt" replace />} />

      {/* Catch All */}
      <Route path="*" element={<AppLayout><NotFoundPage /></AppLayout>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="app-container">
      <AnalyticsManager />
      <AppRoutes />
    </div>
  );
}
